/* eslint-disable global-require */
/* eslint-disable import/prefer-default-export */
import Web3 from "web3";
import { ENVIRONMENT } from "configs";
import NFTContract from "configs/abis/NFTMarketplace.json";
import GACContract from "configs/abis/GAC.json";
import toast from "react-hot-toast";

window.Buffer = window.Buffer || require("buffer").Buffer;

const web3 = new Web3(
  Web3.givenProvider || "ws://some.local-or-remote.node:8546"
);

export const purchaseNFT = async (tokenData) => {
  const account = await web3.eth.getAccounts();
  let res;
  if (account.length !== 0) {
    const contract = new web3.eth.Contract(
      NFTContract.abi,
      ENVIRONMENT.CONTRACT_ADDRESS
    );
    const tokenContract = new web3.eth.Contract(
      GACContract.abi,
      ENVIRONMENT.GAC_CONTRACT_ADDRESS
    );
    const approve = await tokenContract.methods
      .approve(ENVIRONMENT.CONTRACT_ADDRESS, tokenData.price)
      .send({
        from: account[0],
      });
    if (approve.status === true) {
      res = await contract.methods.purchaseNFTItem(tokenData.tokenId).send({
        from: account[0],
      });
    }
    return res;
  }
  return toast("Connect your wallet before purchase.", {
    position: "bottom-center",
    icon: "⚠️",
  });
};
